export const rsuiteInputOnchangeFormikHandler = (formikOnChange) => (inputValue, syntheticEvent) => {
    return formikOnChange(syntheticEvent);
}

export const rsuiteSelectOnchangeFormikHandler = (formikOnChange, name) => (selectValue) => {
    const data = {
        target: {
            name,
            value: selectValue
        }
    }
    return formikOnChange(data);
}


export const rsuiteAutocompleteOnchangeFormikHandler = (formikOnChange, name) => (inputValue, syntheticEvent) => {
    if(syntheticEvent.type === 'change') {
        return formikOnChange(syntheticEvent);
    }

    if(syntheticEvent.type === 'click') {
        return formikOnChange({
            target: {
                name,
                value: inputValue
            }
        });
    }
}

export const rsuiteInputPickerOnchangeFormikHandler = (formikOnChange, name, data, setData) => async(inputValue, syntheticEvent) => {

    const searchedValue = data.find(item => item.value === inputValue);
        let formikValue = { label: inputValue, value: inputValue };

        if (searchedValue) {
            formikValue = searchedValue;
        } else {
            await setData([...data, formikValue]);
        }
        formikOnChange({
            target: {
                name,
                value: formikValue
            }
        })
}

 export const rsuiteUploadFormikHandler = (formikOnChange, name) => (uploadValue) => {

    const reader = new FileReader();
    reader.readAsDataURL(uploadValue[0].blobFile);
    reader.onload = (e) => {
      uploadValue[0].base64 = e.target.result.toString().replace(/^data:(.*,)?/, '')
    };

         const data = {
             target: {
                 name,
                 value: uploadValue[0]
             }
         }
         return formikOnChange(data);
     }
